<template>
  <layout kind="one_column">
    <v-container fluid pt-0 mt-0 pb-0>
      <v-layout row wrap>
        <v-flex xs12 mb-3>
          <h1 class="max">{{i18n('Compartilhar conta')}}</h1>
        </v-flex>
        <v-flex xs12>
          <v-card class="mb-3" style="border-radius: 10px;">
            <v-container>
              <v-layout row wrap px-3>
                <v-flex xs12>
                  <h3 class="text-xs-center display-1 background-color">{{i18n('Atenção')}}</h3>
                  <p class="text-xs-center title font-weight-thin mt-3" style="line-height: 40px!important;">
                  {{i18n('Ao fornecer o código de compartilhamento a terceiros, estes poderão realizar transações')}}<br /> {{i18n('financeiras em seu nome por meio da FacilitaPay.')}}
                  </p>
                  <div class="text-xs-center mt-5 mb-5">
                    <v-btn style="height: 80px!important; " dark round large class="elevation-5 btn-style--tertiary" @click="loadAccountShareCode" v-if="account_share_code === null">{{i18n('Exibir código')}}</v-btn>
                    <div class="elevation-5" style="max-width: 350px; margin: auto; border-radius: 25px; padding: 15px 10px 15px 10px; min-height: 80px!important;" v-if="account_share_code !== null">
                      <span class="label">{{i18n('Código')}}:</span> <span class="value">{{account_share_code}}</span><br />
                      <span class="label">{{i18n('Tipo Documento')}}:</span> <span class="value">{{document_type.toUpperCase()}}</span><br />
                      <span class="label">{{i18n('Número Documento')}}:</span> <span class="value">{{mask(document_type, document_number)}}</span>
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </layout>
</template>

<script>
import LeftBarLayout from "./layouts/LeftBarLayout"
import banks from "./shared/Banks"
import utils from "./shared/Utils"

export default {
  name: 'AccountShareCode',
  components: { layout: LeftBarLayout },
  data: () => {
    return {
      account_share_code: null,
      document_number: null,
      document_type: null
    }
  },
  computed: {
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    mask(document_type, document_number) {
      return utils.mask(document_type, document_number)
    },
    loadAccountShareCode() {
      let successCallback = (response) => {
        if (response.body.data && response.body.data.account_share_code) {
          this.account_share_code = response.body.data.account_share_code 
          this.document_number = response.body.data.document_number 
          this.document_type = response.body.data.document_type 
        }
      }

      let errorCallback = (response) => {
        console.log(response)
      }

      const token = this.$cookies.get('api_token')
      this.$http.get(this.$root.urls.account_share_code, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
    },
  },
  mounted() {
    this.$root.authenticationStore.redirectIfNotAuthenticated()
    let has_registered_company = this.$cookies.isKey('company_id') && this.$cookies.get('company_id') !== ''

    if (!has_registered_company) {
      this.$router.push('/')
      return
    }
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}
</script>

<style>
  span.label {
    color: var(--background-color);
    font-weight: bold;
    font-style: italic;
  }
  span.value {
    font-size: 16px;
    font-weight: bold;
    color: var(--secondary-button-background-color);
  }
  .background-color {
    color: var(--background-color);
  }
</style>



// WEBPACK FOOTER //
// src/AccountShareCode.vue